<template>
  <div>
    <div v-for="(obj, key) in diff" :key="key">
      <h5 class="mb-1 p-0 h6">{{ obj.title }}</h5>
      <d-list-group class="mb-4">
        <d-list-group-item
          v-for="(v, k) in obj.values"
          :key="`${key}_${k}`"
          class="p-0"
        >
          <d-row>
            <d-col cols="12" md="2">
              <div class="bg-light h-100 w-100 radius-1 d-flex justify-content-start align-items-center">
                <h6 class="diff-title px-1 m-0">{{ k }}</h6>
              </div>
            </d-col>
            <d-col cols="12" md="10">
              <span class="diff-value diff-old" title="Old Value">{{ v.old }}</span>
              <i class="material-icons ml-1 mr-3 text-info">arrow_right_alt</i>
              <span class="diff-value diff-new" title="New Value">{{ v.new }}</span>
            </d-col>
          </d-row>
        </d-list-group-item>
      </d-list-group>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    diff: Object
  }
};
</script>

<style lang="scss">
.diff-title {
  font-size: 0.75rem;
  font-weight: 400;
}

.diff-value {
  font-size: 0.9rem;
}

.diff-old {
    font-size: 0.9rem;
    opacity:0.5
}

.diff-new {
    font-size: 1.05rem;
}
</style>
